import { render, staticRenderFns } from "./communicationDialog.vue?vue&type=template&id=0831abae&scoped=true"
import script from "./communicationDialog.vue?vue&type=script&lang=js"
export * from "./communicationDialog.vue?vue&type=script&lang=js"
import style0 from "./communicationDialog.vue?vue&type=style&index=0&id=0831abae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831abae",
  null
  
)

export default component.exports